import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'

const _4f55ef38 = () => interopDefault(import('..\\pages\\about.vue' /* webpackChunkName: "pages_about" */))
const _24c7704e = () => interopDefault(import('..\\pages\\activity\\index.vue' /* webpackChunkName: "pages_activity_index" */))
const _4d3dd201 = () => interopDefault(import('..\\pages\\article\\index.vue' /* webpackChunkName: "pages_article_index" */))
const _91e5266a = () => interopDefault(import('..\\pages\\baidu_verify_dl6gj1sBLN.html.vue' /* webpackChunkName: "pages_baidu_verify_dl6gj1sBLN.html" */))
const _368e9708 = () => interopDefault(import('..\\pages\\forgot.vue' /* webpackChunkName: "pages_forgot" */))
const _6f7484cf = () => interopDefault(import('..\\pages\\join.vue' /* webpackChunkName: "pages_join" */))
const _b99345c8 = () => interopDefault(import('..\\pages\\library\\index.vue' /* webpackChunkName: "pages_library_index" */))
const _38b56d14 = () => interopDefault(import('..\\pages\\login.vue' /* webpackChunkName: "pages_login" */))
const _162535f8 = () => interopDefault(import('..\\pages\\news.vue' /* webpackChunkName: "pages_news" */))
const _195b3f93 = () => interopDefault(import('..\\pages\\pay.vue' /* webpackChunkName: "pages_pay" */))
const _01dcb970 = () => interopDefault(import('..\\pages\\register.vue' /* webpackChunkName: "pages_register" */))
const _fe5f26fc = () => interopDefault(import('..\\pages\\room\\index.vue' /* webpackChunkName: "pages_room_index" */))
const _1e6a4f0d = () => interopDefault(import('..\\pages\\search.vue' /* webpackChunkName: "pages_search" */))
const _299868dc = () => interopDefault(import('..\\pages\\user\\index.vue' /* webpackChunkName: "pages_user_index" */))
const _74bfc0b0 = () => interopDefault(import('..\\pages\\user\\index\\index.vue' /* webpackChunkName: "pages_user_index_index" */))
const _fe8a96a4 = () => interopDefault(import('..\\pages\\user\\index\\article\\index.vue' /* webpackChunkName: "pages_user_index_article_index" */))
const _244c426e = () => interopDefault(import('..\\pages\\user\\index\\fcoins.vue' /* webpackChunkName: "pages_user_index_fcoins" */))
const _1895b38d = () => interopDefault(import('..\\pages\\user\\index\\gcoins.vue' /* webpackChunkName: "pages_user_index_gcoins" */))
const _a69423aa = () => interopDefault(import('..\\pages\\user\\index\\home-message.vue' /* webpackChunkName: "pages_user_index_home-message" */))
const _59064212 = () => interopDefault(import('..\\pages\\user\\index\\honer.vue' /* webpackChunkName: "pages_user_index_honer" */))
const _628c1b9e = () => interopDefault(import('..\\pages\\user\\index\\inbox\\index.vue' /* webpackChunkName: "pages_user_index_inbox_index" */))
const _b57237b6 = () => interopDefault(import('..\\pages\\user\\index\\income-statistics.vue' /* webpackChunkName: "pages_user_index_income-statistics" */))
const _40b95f9b = () => interopDefault(import('..\\pages\\user\\index\\invite.vue' /* webpackChunkName: "pages_user_index_invite" */))
const _53269040 = () => interopDefault(import('..\\pages\\user\\index\\level\\index.vue' /* webpackChunkName: "pages_user_index_level_index" */))
const _4d43c778 = () => interopDefault(import('..\\pages\\user\\index\\live\\index.vue' /* webpackChunkName: "pages_user_index_live_index" */))
const _8771595a = () => interopDefault(import('..\\pages\\user\\index\\outbox\\index.vue' /* webpackChunkName: "pages_user_index_outbox_index" */))
const _1187c27a = () => interopDefault(import('..\\pages\\user\\index\\pay-statistics.vue' /* webpackChunkName: "pages_user_index_pay-statistics" */))
const _72a57e0a = () => interopDefault(import('..\\pages\\user\\index\\question\\index.vue' /* webpackChunkName: "pages_user_index_question_index" */))
const _1c3b9b34 = () => interopDefault(import('..\\pages\\user\\index\\teacher-like.vue' /* webpackChunkName: "pages_user_index_teacher-like" */))
const _798ac1f9 = () => interopDefault(import('..\\pages\\user\\index\\viewpoint\\index.vue' /* webpackChunkName: "pages_user_index_viewpoint_index" */))
const _21865827 = () => interopDefault(import('..\\pages\\user\\index\\vip\\index.vue' /* webpackChunkName: "pages_user_index_vip_index" */))
const _40bf41e8 = () => interopDefault(import('..\\pages\\user\\index\\voucher.vue' /* webpackChunkName: "pages_user_index_voucher" */))
const _199c9afe = () => interopDefault(import('..\\pages\\user\\index\\article\\deliver.vue' /* webpackChunkName: "pages_user_index_article_deliver" */))
const _6da2e0f8 = () => interopDefault(import('..\\pages\\user\\index\\article\\order-record.vue' /* webpackChunkName: "pages_user_index_article_order-record" */))
const _0de0b09a = () => interopDefault(import('..\\pages\\user\\index\\level\\record.vue' /* webpackChunkName: "pages_user_index_level_record" */))
const _7212e70a = () => interopDefault(import('..\\pages\\user\\index\\live\\as-guest.vue' /* webpackChunkName: "pages_user_index_live_as-guest" */))
const _0c6ed0e4 = () => interopDefault(import('..\\pages\\user\\index\\question\\deblock.vue' /* webpackChunkName: "pages_user_index_question_deblock" */))
const _66f04bad = () => interopDefault(import('..\\pages\\user\\index\\viewpoint\\package.vue' /* webpackChunkName: "pages_user_index_viewpoint_package" */))
const _774bb59e = () => interopDefault(import('..\\pages\\user\\index\\viewpoint\\single.vue' /* webpackChunkName: "pages_user_index_viewpoint_single" */))
const _7b564cc1 = () => interopDefault(import('..\\pages\\user\\index\\vip\\orderlist.vue' /* webpackChunkName: "pages_user_index_vip_orderlist" */))
const _59ef24f4 = () => interopDefault(import('..\\pages\\user\\index\\inbox\\_id.vue' /* webpackChunkName: "pages_user_index_inbox__id" */))
const _76280e7b = () => interopDefault(import('..\\pages\\user\\index\\outbox\\_id.vue' /* webpackChunkName: "pages_user_index_outbox__id" */))
const _46fb16fa = () => interopDefault(import('..\\pages\\vip\\index.vue' /* webpackChunkName: "pages_vip_index" */))
const _ebf86c3a = () => interopDefault(import('..\\pages\\article\\list\\index.vue' /* webpackChunkName: "pages_article_list_index" */))
const _3e7d7718 = () => interopDefault(import('..\\pages\\question\\teacher-list.vue' /* webpackChunkName: "pages_question_teacher-list" */))
const _353a191e = () => interopDefault(import('..\\pages\\room\\apply.vue' /* webpackChunkName: "pages_room_apply" */))
const _313575dc = () => interopDefault(import('..\\pages\\vip\\edit.vue' /* webpackChunkName: "pages_vip_edit" */))
const _e7b65e10 = () => interopDefault(import('..\\pages\\article\\detail\\_id.vue' /* webpackChunkName: "pages_article_detail__id" */))
const _42b0e90b = () => interopDefault(import('..\\pages\\article\\list\\_id.vue' /* webpackChunkName: "pages_article_list__id" */))
const _2e67618e = () => interopDefault(import('..\\pages\\question\\detail\\_id.vue' /* webpackChunkName: "pages_question_detail__id" */))
const _6c6aa721 = () => interopDefault(import('..\\pages\\question\\list\\_id.vue' /* webpackChunkName: "pages_question_list__id" */))
const _02038593 = () => interopDefault(import('..\\pages\\room\\history-list\\_id.vue' /* webpackChunkName: "pages_room_history-list__id" */))
const _b77f2eb4 = () => interopDefault(import('..\\pages\\room\\history\\_id.vue' /* webpackChunkName: "pages_room_history__id" */))
const _1fceb731 = () => interopDefault(import('..\\pages\\vip\\detail\\_id.vue' /* webpackChunkName: "pages_vip_detail__id" */))
const _b4efa432 = () => interopDefault(import('..\\pages\\vip\\room\\_id.vue' /* webpackChunkName: "pages_vip_room__id" */))
const _a9d8299a = () => interopDefault(import('..\\pages\\intro\\_id.vue' /* webpackChunkName: "pages_intro__id" */))
const _3bef1f30 = () => interopDefault(import('..\\pages\\library\\_book\\index.vue' /* webpackChunkName: "pages_library__book_index" */))
const _57245a80 = () => interopDefault(import('..\\pages\\question\\_t.vue' /* webpackChunkName: "pages_question__t" */))
const _4f33a76a = () => interopDefault(import('..\\pages\\room\\_id.vue' /* webpackChunkName: "pages_room__id" */))
const _7fd52420 = () => interopDefault(import('..\\pages\\library\\_book\\_chapter.vue' /* webpackChunkName: "pages_library__book__chapter" */))
const _6f0dc9fd = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

Vue.use(Router)

const scrollBehavior = (to, from, saved) => {
      if (saved) {
        return saved
      } else if (to.path === from.path) {
        // 点击分页时
        let y
        switch (to.name) {
          case 'about':
            y = 0
            break
          case 'article-list':
            y = 110
            break
          case 'news':
            y = 100
            break
          case 'question-teacher-list':
            y = 120
            break
          case 'article-list-id':
          case 'question-list-id':
          case 'room-history-list-id':
            y = 285
            break
          case 'question-t':
          case 'vip':
            y = 403
            break
        }
        return { x: 0, y }
      } else if (to.matched.some((r) => r.components.default.options.scrollToTop)) {
        return { x: 0, y: 0 }
      } else {
        return { x: 0, y: 0 }
      }
    }

export function createRouter() {
  return new Router({
    mode: 'history',
    base: '/',
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,

    routes: [{
      path: "/about",
      component: _4f55ef38,
      name: "about"
    }, {
      path: "/activity",
      component: _24c7704e,
      name: "activity"
    }, {
      path: "/article",
      component: _4d3dd201,
      name: "article"
    }, {
      path: "/baidu_verify_dl6gj1sBLN.html",
      component: _91e5266a,
      name: "baidu_verify_dl6gj1sBLN.html"
    }, {
      path: "/forgot",
      component: _368e9708,
      name: "forgot"
    }, {
      path: "/join",
      component: _6f7484cf,
      name: "join"
    }, {
      path: "/library",
      component: _b99345c8,
      name: "library"
    }, {
      path: "/login",
      component: _38b56d14,
      name: "login"
    }, {
      path: "/news",
      component: _162535f8,
      name: "news"
    }, {
      path: "/pay",
      component: _195b3f93,
      name: "pay"
    }, {
      path: "/register",
      component: _01dcb970,
      name: "register"
    }, {
      path: "/room",
      component: _fe5f26fc,
      name: "room"
    }, {
      path: "/search",
      component: _1e6a4f0d,
      name: "search"
    }, {
      path: "/user",
      component: _299868dc,
      children: [{
        path: "",
        component: _74bfc0b0,
        name: "user-index"
      }, {
        path: "article",
        component: _fe8a96a4,
        name: "user-index-article"
      }, {
        path: "fcoins",
        component: _244c426e,
        name: "user-index-fcoins"
      }, {
        path: "gcoins",
        component: _1895b38d,
        name: "user-index-gcoins"
      }, {
        path: "home-message",
        component: _a69423aa,
        name: "user-index-home-message"
      }, {
        path: "honer",
        component: _59064212,
        name: "user-index-honer"
      }, {
        path: "inbox",
        component: _628c1b9e,
        name: "user-index-inbox"
      }, {
        path: "income-statistics",
        component: _b57237b6,
        name: "user-index-income-statistics"
      }, {
        path: "invite",
        component: _40b95f9b,
        name: "user-index-invite"
      }, {
        path: "level",
        component: _53269040,
        name: "user-index-level"
      }, {
        path: "live",
        component: _4d43c778,
        name: "user-index-live"
      }, {
        path: "outbox",
        component: _8771595a,
        name: "user-index-outbox"
      }, {
        path: "pay-statistics",
        component: _1187c27a,
        name: "user-index-pay-statistics"
      }, {
        path: "question",
        component: _72a57e0a,
        name: "user-index-question"
      }, {
        path: "teacher-like",
        component: _1c3b9b34,
        name: "user-index-teacher-like"
      }, {
        path: "viewpoint",
        component: _798ac1f9,
        name: "user-index-viewpoint"
      }, {
        path: "vip",
        component: _21865827,
        name: "user-index-vip"
      }, {
        path: "voucher",
        component: _40bf41e8,
        name: "user-index-voucher"
      }, {
        path: "article/deliver",
        component: _199c9afe,
        name: "user-index-article-deliver"
      }, {
        path: "article/order-record",
        component: _6da2e0f8,
        name: "user-index-article-order-record"
      }, {
        path: "level/record",
        component: _0de0b09a,
        name: "user-index-level-record"
      }, {
        path: "live/as-guest",
        component: _7212e70a,
        name: "user-index-live-as-guest"
      }, {
        path: "question/deblock",
        component: _0c6ed0e4,
        name: "user-index-question-deblock"
      }, {
        path: "viewpoint/package",
        component: _66f04bad,
        name: "user-index-viewpoint-package"
      }, {
        path: "viewpoint/single",
        component: _774bb59e,
        name: "user-index-viewpoint-single"
      }, {
        path: "vip/orderlist",
        component: _7b564cc1,
        name: "user-index-vip-orderlist"
      }, {
        path: "inbox/:id?",
        component: _59ef24f4,
        name: "user-index-inbox-id"
      }, {
        path: "outbox/:id?",
        component: _76280e7b,
        name: "user-index-outbox-id"
      }]
    }, {
      path: "/vip",
      component: _46fb16fa,
      name: "vip"
    }, {
      path: "/article/list",
      component: _ebf86c3a,
      name: "article-list"
    }, {
      path: "/question/teacher-list",
      component: _3e7d7718,
      name: "question-teacher-list"
    }, {
      path: "/room/apply",
      component: _353a191e,
      name: "room-apply"
    }, {
      path: "/vip/edit",
      component: _313575dc,
      name: "vip-edit"
    }, {
      path: "/article/detail/:id?",
      component: _e7b65e10,
      name: "article-detail-id"
    }, {
      path: "/article/list/:id",
      component: _42b0e90b,
      name: "article-list-id"
    }, {
      path: "/question/detail/:id?",
      component: _2e67618e,
      name: "question-detail-id"
    }, {
      path: "/question/list/:id?",
      component: _6c6aa721,
      name: "question-list-id"
    }, {
      path: "/room/history-list/:id?",
      component: _02038593,
      name: "room-history-list-id"
    }, {
      path: "/room/history/:id?",
      component: _b77f2eb4,
      name: "room-history-id"
    }, {
      path: "/vip/detail/:id?",
      component: _1fceb731,
      name: "vip-detail-id"
    }, {
      path: "/vip/room/:id?",
      component: _b4efa432,
      name: "vip-room-id"
    }, {
      path: "/intro/:id?",
      component: _a9d8299a,
      name: "intro-id"
    }, {
      path: "/library/:book",
      component: _3bef1f30,
      name: "library-book"
    }, {
      path: "/question/:t?",
      component: _57245a80,
      name: "question-t"
    }, {
      path: "/room/:id",
      component: _4f33a76a,
      name: "room-id"
    }, {
      path: "/library/:book/:chapter",
      component: _7fd52420,
      name: "library-book-chapter"
    }, {
      path: "/",
      component: _6f0dc9fd,
      name: "index"
    }],

    fallback: false
  })
}
